import axios from 'axios'
import qs from 'qs'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiWalletStatementBalance, ApiResult } from 'Types'

const endpoint = `${apiUrl.stable}/balanco`

/** Returns the wallet balance from the current signed user */
export const getBalance = (isBlocked: boolean = false): ApiResult<ApiWalletStatementBalance> => {
  const url = `${endpoint}/saldo`

  const headers = { ...jsonWebToken.header }
  const params = qs.stringify({ isBlocked })

  return axios.get(url, { headers, params })
}

export default {
  getBalance
}